<template>
    <nav class="global-navigation">
        <ul class="navigation-list">
            <li class="navigation-item">
                <a
                    class="navigation-link"
                    :class="{ 'is-current': currentPage === 'search' }"
                    href="/search"
                >
                    <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.51926 15.6152C7.81159 15.6152 6.36542 15.023 5.18076 13.8385C3.99626 12.6538 3.40401 11.2077 3.40401 9.5C3.40401 7.79233 3.99626 6.34617 5.18076 5.1615C6.36542 3.977 7.81159 3.38475 9.51926 3.38475C11.2269 3.38475 12.6731 3.977 13.8578 5.1615C15.0423 6.34617 15.6345 7.79233 15.6345 9.5C15.6345 10.2142 15.5147 10.8963 15.275 11.5463C15.0352 12.1962 14.7153 12.7616 14.3153 13.2423L20.0693 18.9962C20.2078 19.1346 20.2786 19.3086 20.2818 19.5182C20.2849 19.7279 20.2141 19.9052 20.0693 20.05C19.9244 20.1948 19.7488 20.2673 19.5423 20.2673C19.3359 20.2673 19.1603 20.1948 19.0155 20.05L13.2615 14.296C12.7615 14.7088 12.1865 15.0319 11.5365 15.2653C10.8865 15.4986 10.2141 15.6152 9.51926 15.6152ZM9.51926 14.1155C10.8078 14.1155 11.8991 13.6683 12.7933 12.774C13.6876 11.8798 14.1348 10.7885 14.1348 9.5C14.1348 8.2115 13.6876 7.12017 12.7933 6.226C11.8991 5.33167 10.8078 4.8845 9.51926 4.8845C8.23076 4.8845 7.13942 5.33167 6.24526 6.226C5.35092 7.12017 4.90376 8.2115 4.90376 9.5C4.90376 10.7885 5.35092 11.8798 6.24526 12.774C7.13942 13.6683 8.23076 14.1155 9.51926 14.1155Z" fill="currentColor"></path></svg>
                    <span class="navigation-label">さがす</span>
                </a>
            </li>
            <li class="navigation-item">
                <a
                    class="navigation-link"
                    :class="{ 'is-current': currentPage === 'event' }"
                    href="/event/list"
                >
                    <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.2169 12.4934H19.0079C18.7857 12.4934 18.5997 12.4187 18.4498 12.2693C18.2998 12.1201 18.2248 11.9348 18.2248 11.7135C18.2248 11.4922 18.2998 11.3069 18.4498 11.1577C18.5997 11.0083 18.7857 10.9337 19.0079 10.9337H21.2169C21.4391 10.9337 21.6251 11.0083 21.775 11.1577C21.925 11.3069 22 11.4922 22 11.7135C22 11.9348 21.925 12.1201 21.775 12.2693C21.6251 12.4187 21.4391 12.4934 21.2169 12.4934ZM16.8734 16.6147C17.0072 16.4321 17.1783 16.3267 17.3866 16.2986C17.5947 16.2707 17.7905 16.3234 17.9739 16.4567L19.7349 17.7744C19.9184 17.9078 20.0241 18.0782 20.0521 18.2855C20.0803 18.4927 20.0274 18.6877 19.8934 18.8704C19.7596 19.0529 19.5886 19.1581 19.3804 19.1862C19.1723 19.2143 18.9765 19.1616 18.7931 19.0282L17.0321 17.7104C16.8487 17.5772 16.743 17.4069 16.7149 17.1996C16.6867 16.9924 16.7396 16.7974 16.8734 16.6147ZM19.6947 5.61261L17.9337 6.93032C17.7503 7.0636 17.5545 7.11628 17.3464 7.08838C17.1383 7.0603 16.9672 6.95493 16.8332 6.77227C16.6994 6.58978 16.6465 6.39481 16.6747 6.18737C16.7028 5.9801 16.8085 5.80983 16.9919 5.67656L18.7529 4.35884C18.9363 4.22557 19.1321 4.17288 19.3402 4.20079C19.5484 4.22886 19.7194 4.33414 19.8534 4.51663C19.9873 4.6993 20.0401 4.89426 20.0119 5.10153C19.9839 5.30898 19.8782 5.47934 19.6947 5.61261ZM4.95186 14.3931H3.8876C3.3669 14.3931 2.92217 14.2094 2.55341 13.842C2.18447 13.4748 2 13.0319 2 12.5134V10.9136C2 10.3951 2.18447 9.95223 2.55341 9.585C2.92217 9.21759 3.3669 9.03389 3.8876 9.03389H7.92383L11.1707 7.10034C11.4853 6.9123 11.8026 6.91065 12.1224 7.0954C12.4425 7.27997 12.6025 7.55153 12.6025 7.9101V15.5169C12.6025 15.8755 12.4425 16.1471 12.1224 16.3316C11.8026 16.5164 11.4853 16.5147 11.1707 16.3267L7.92383 14.3931H6.51812V17.6725C6.51812 17.8938 6.44311 18.0791 6.2931 18.2283C6.14326 18.3777 5.95722 18.4524 5.73499 18.4524C5.51276 18.4524 5.32672 18.3777 5.17688 18.2283C5.02687 18.0791 4.95186 17.8938 4.95186 17.6725V14.3931ZM11.0362 14.4012V9.02583L8.35742 10.5936H3.8876C3.80737 10.5936 3.73375 10.627 3.66675 10.6937C3.59975 10.7604 3.56625 10.8337 3.56625 10.9136V12.5134C3.56625 12.5933 3.59975 12.6666 3.66675 12.7333C3.73375 12.8 3.80737 12.8334 3.8876 12.8334H8.35742L11.0362 14.4012ZM14.0481 14.957V8.47004C14.4578 8.83936 14.7878 9.30459 15.038 9.86575C15.2884 10.4271 15.4136 11.043 15.4136 11.7135C15.4136 12.384 15.2884 13 15.038 13.5613C14.7878 14.1224 14.4578 14.5877 14.0481 14.957Z" fill="currentColor"></path></svg>
                    <span class="navigation-label">イベント</span>
                </a>
            </li>
            <li class="navigation-item">
                <a
                    class="navigation-link"
                    :class="{ 'is-current': currentPage === 'good' }"
                    href="/good/list"
                >
                <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.991 19.5C11.7881 19.5 11.5843 19.4652 11.3797 19.3956C11.1751 19.3259 10.995 19.2167 10.8395 19.0681L9.47858 17.8854C7.7989 16.421 6.29921 14.9824 4.97953 13.5696C3.65984 12.1568 3 10.6433 3 9.02912C3 7.74361 3.45332 6.66734 4.35995 5.80031C5.26674 4.93344 6.39237 4.5 7.73684 4.5C8.50074 4.5 9.25532 4.66841 10.0006 5.00522C10.7457 5.34204 11.4122 5.88901 12 6.64612C12.5878 5.88901 13.2543 5.34204 13.9994 5.00522C14.7447 4.66841 15.4993 4.5 16.2632 4.5C17.6076 4.5 18.7333 4.93344 19.6401 5.80031C20.5467 6.66734 21 7.74361 21 9.02912C21 10.6608 20.3289 12.1911 18.9868 13.6201C17.6447 15.049 16.1484 16.4754 14.4977 17.8992L13.1513 19.0681C12.9959 19.2167 12.8144 19.3259 12.6068 19.3956C12.399 19.4652 12.1937 19.5 11.991 19.5ZM11.3186 8.0223C10.8061 7.2756 10.2665 6.72833 9.69979 6.38049C9.13326 6.03265 8.47895 5.85874 7.73684 5.85874C6.78947 5.85874 6 6.16068 5.36842 6.76456C4.73684 7.36844 4.42105 8.1233 4.42105 9.02912C4.42105 9.75605 4.66611 10.5161 5.15621 11.3093C5.64632 12.1025 6.26147 12.891 7.00168 13.6749C7.74189 14.4589 8.54384 15.2247 9.40753 15.9725C10.2711 16.7204 11.0714 17.4155 11.8086 18.0577C11.8633 18.1042 11.9271 18.1274 12 18.1274C12.0729 18.1274 12.1367 18.1042 12.1914 18.0577C12.9286 17.4155 13.7289 16.7204 14.5925 15.9725C15.4562 15.2247 16.2581 14.4589 16.9983 13.6749C17.7385 12.891 18.3537 12.1025 18.8438 11.3093C19.3339 10.5161 19.5789 9.75605 19.5789 9.02912C19.5789 8.1233 19.2632 7.36844 18.6316 6.76456C18 6.16068 17.2105 5.85874 16.2632 5.85874C15.5211 5.85874 14.8667 6.03265 14.3002 6.38049C13.7335 6.72833 13.1939 7.2756 12.6814 8.0223C12.6012 8.13839 12.5004 8.22551 12.3789 8.28363C12.2575 8.3416 12.1312 8.37059 12 8.37059C11.8688 8.37059 11.7425 8.3416 11.6211 8.28363C11.4996 8.22551 11.3988 8.13839 11.3186 8.0223Z" fill="currentColor"></path></svg>
                <span class="navigation-label">相手から</span>
                <span class="navigation-badge" v-if="hasLikeBadge" aria-hidden="true"></span>
                </a>
            </li>
            <li class="navigation-item">
                <a
                    class="navigation-link"
                    :class="{ 'is-current': currentPage === 'congratulation' }"
                    href="/congratulation/list"
                >
                    <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75429 17.1088C8.54437 17.1088 8.35273 17.0114 8.17939 16.8165C8.00604 16.6217 7.91937 16.4164 7.91937 16.2005V14.2968H16.364V8.11424H18.1816C18.3839 8.11424 18.5709 8.21166 18.7425 8.4065C18.9142 8.60135 19 8.81255 19 9.0401V18.2917C19 18.6035 18.8656 18.8189 18.5969 18.938C18.3281 19.0571 18.0888 19.0046 17.8789 18.7807L16.3116 17.1088H8.75429ZM7.75151 13.2409L6.12114 14.9801C5.91121 15.204 5.67187 15.2581 5.40312 15.1424C5.13437 15.0266 5 14.8128 5 14.5011V5.90826C5 5.69244 5.08583 5.48711 5.25749 5.29226C5.42914 5.09742 5.61923 5 5.82776 5H14.5392C14.7525 5 14.945 5.09449 15.1166 5.28346C15.2883 5.47244 15.3741 5.68071 15.3741 5.90826V12.3326C15.3741 12.5551 15.2883 12.7621 15.1166 12.9536C14.945 13.1451 14.7525 13.2409 14.5392 13.2409H7.75151ZM14.0672 11.8467V6.40409H6.31624V11.8467H14.0672Z" fill="currentColor"></path></svg>
                    <span class="navigation-label">メッセージ</span>
                    <span class="navigation-badge" v-if="hasMatchingBadge" aria-hidden="true"></span>
                </a>
            </li>
            <li class="navigation-item">
                <a
                    class="navigation-link"
                    :class="{ 'is-current': currentPage === 'home' }"
                    href="/home"
                >
                    <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.023 17.2923C6.873 16.6616 7.799 16.1635 8.801 15.798C9.80283 15.4327 10.8692 15.25 12 15.25C13.1308 15.25 14.1972 15.4327 15.199 15.798C16.201 16.1635 17.127 16.6616 17.977 17.2923C18.5987 16.6089 19.0912 15.8179 19.4548 14.9192C19.8183 14.0206 20 13.0475 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 13.0475 4.18175 14.0206 4.54525 14.9192C4.90875 15.8179 5.40133 16.6089 6.023 17.2923ZM12.0003 12.75C11.0873 12.75 10.3173 12.4367 9.6905 11.81C9.0635 11.1832 8.75 10.4133 8.75 9.50025C8.75 8.58725 9.06333 7.81733 9.69 7.1905C10.3168 6.5635 11.0868 6.25 11.9998 6.25C12.9128 6.25 13.6827 6.56333 14.3095 7.19C14.9365 7.81683 15.25 8.58675 15.25 9.49975C15.25 10.4127 14.9367 11.1827 14.31 11.8095C13.6832 12.4365 12.9132 12.75 12.0003 12.75ZM12 21.5C10.6808 21.5 9.44333 21.2519 8.2875 20.7558C7.13167 20.2596 6.12625 19.5839 5.27125 18.7288C4.41608 17.8738 3.74042 16.8683 3.24425 15.7125C2.74808 14.5567 2.5 13.3192 2.5 12C2.5 10.6808 2.74808 9.44333 3.24425 8.2875C3.74042 7.13167 4.41608 6.12625 5.27125 5.27125C6.12625 4.41608 7.13167 3.74042 8.2875 3.24425C9.44333 2.74808 10.6808 2.5 12 2.5C13.3192 2.5 14.5567 2.74808 15.7125 3.24425C16.8683 3.74042 17.8738 4.41608 18.7288 5.27125C19.5839 6.12625 20.2596 7.13167 20.7558 8.2875C21.2519 9.44333 21.5 10.6808 21.5 12C21.5 13.3192 21.2519 14.5567 20.7558 15.7125C20.2596 16.8683 19.5839 17.8738 18.7288 18.7288C17.8738 19.5839 16.8683 20.2596 15.7125 20.7558C14.5567 21.2519 13.3192 21.5 12 21.5ZM12 20C12.9025 20 13.7727 19.8548 14.6105 19.5645C15.4483 19.274 16.1923 18.8679 16.8422 18.3462C16.1923 17.8436 15.458 17.4519 14.6395 17.1712C13.8208 16.8904 12.941 16.75 12 16.75C11.059 16.75 10.1776 16.8888 9.35575 17.1663C8.53392 17.4439 7.80125 17.8372 7.15775 18.3462C7.80775 18.8679 8.55167 19.274 9.3895 19.5645C10.2273 19.8548 11.0975 20 12 20ZM12 11.25C12.4975 11.25 12.9135 11.0827 13.248 10.748C13.5827 10.4135 13.75 9.9975 13.75 9.5C13.75 9.0025 13.5827 8.5865 13.248 8.252C12.9135 7.91733 12.4975 7.75 12 7.75C11.5025 7.75 11.0865 7.91733 10.752 8.252C10.4173 8.5865 10.25 9.0025 10.25 9.5C10.25 9.9975 10.4173 10.4135 10.752 10.748C11.0865 11.0827 11.5025 11.25 12 11.25Z" fill="currentColor"></path></svg>
                    <span class="navigation-label">マイページ</span>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: 'FooterMenu',
    props: {
        currentPage: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            likeUnreadBadge: false,
            matchingUnreadBadge: false,
            unreadBadgePollingId: null,
            LUNA_LIKES_LAST_VIEWED_AT: 'lunaLikesLastViewedAt',
            LUNA_MATCHINGS_LAST_VIEWED_AT: 'lunaMatchingsLastViewedAt',
            authRetryCount: 0, // 401エラーのリトライカウンター
            MAX_AUTH_RETRIES: 3, // 最大リトライ回数
        }
    },
    computed: {
        hasLikeBadge() {
            return this.likeUnreadBadge
        },
        hasMatchingBadge() {
            return this.matchingUnreadBadge
        }
    },
    mounted() {
        this.startUnreadBadgePolling()
    },
    beforeDestroy() {
        this.stopUnreadBadgePolling()
    },
    methods: {
        startUnreadBadgePolling() {
            this.stopUnreadBadgePolling()
            this.fetchUnreadBadges()
            this.unreadBadgePollingId = setInterval(() => {
                this.fetchUnreadBadges()
            }, 60 * 1000)
        },
        stopUnreadBadgePolling() {
            if (this.unreadBadgePollingId) {
                clearInterval(this.unreadBadgePollingId)
                this.unreadBadgePollingId = null
            }
        },
        async fetchUnreadBadges() {
            const defaultParams = { sort: 'latest', page: 1, per_page: 20 }
            try {
                // localStorageから最終閲覧日時を取得
                const likesLastViewedAt = localStorage.getItem(this.LUNA_LIKES_LAST_VIEWED_AT)
                const matchingsLastViewedAt = localStorage.getItem(this.LUNA_MATCHINGS_LAST_VIEWED_AT)

                const [
                    messageLikesResponse,
                    likesResponse,
                    premiumLikesResponse,
                    matchingsResponse,
                ] = await Promise.all([
                    axios.get('/api/v2/message-likes', { params: defaultParams }),
                    axios.get('/api/v2/likes', { params: defaultParams }),
                    axios.get('/api/v2/premium-message-likes', { params: defaultParams }),
                    axios.get('/api/v2/matchings', { params: { page: 1, per_page: 100 } }),
                ])

                // いいね一覧: created_atで新着判定、かつ is_read が false
                const messageLikes = messageLikesResponse?.data?.messageLikes || []
                const likes = likesResponse?.data?.likes || []
                const premiumLikes = premiumLikesResponse?.data?.premiumMessageLikes || []

                const hasNewLikes =
                    this.hasNewUnreadItemsSince(messageLikes, likesLastViewedAt, 'created_at', 'is_read') ||
                    this.hasNewUnreadItemsSince(likes, likesLastViewedAt, 'created_at', 'is_read') ||
                    this.hasNewUnreadItemsSince(premiumLikes, likesLastViewedAt, 'created_at', 'is_read')

                // マッチング一覧: sort_atで新着判定、かつ is_message_viewed または is_viewed が false
                // ※ is_message_viewed を優先し、無い場合は従来の is_viewed を参照
                const matchings = matchingsResponse?.data?.matchings || []
                const hasNewMatchings = this.hasNewUnreadItemsSince(
                    matchings,
                    matchingsLastViewedAt,
                    'sort_at',
                    ['is_message_viewed', 'is_viewed']
                )

                this.likeUnreadBadge = hasNewLikes
                this.matchingUnreadBadge = hasNewMatchings

                // 成功したらリトライカウンターをリセット
                this.authRetryCount = 0
            } catch (error) {
                if (error && error.response && error.response.status === 401) {
                    this.authRetryCount++
                    console.warn(`認証エラー（リトライ ${this.authRetryCount}/${this.MAX_AUTH_RETRIES}）`, error)

                    if (this.authRetryCount >= this.MAX_AUTH_RETRIES) {
                        // 最大リトライ回数に達した場合のみログアウト
                        console.error('認証エラーが継続しているため、ログアウトします')
                        window.location.href = '/auth?logout=true'
                    } else {
                        // リトライする場合は指数バックオフで待機
                        const backoffDelay = Math.pow(2, this.authRetryCount - 1) * 1000 // 1秒、2秒、4秒...
                        console.log(`${backoffDelay}ms後に再試行します`)
                        setTimeout(() => {
                            this.fetchUnreadBadges()
                        }, backoffDelay)
                    }
                } else {
                    console.error('未読バッジの取得に失敗しました', error)
                }
            }
        },
        /**
         * 指定日時以降に作成/更新された未読アイテムがあるかチェック
         *
         * @param {Array} items - チェック対象のアイテム配列
         * @param {string|null} lastViewedAt - 最後に閲覧した日時（ISO8601形式、nullの場合は1970-01-01T00:00:00Zを使用）
         * @param {string} dateField - 比較する日付フィールド名（'created_at' | 'sort_at'）
         * @param {string|string[]} unreadField - 未読フラグのフィールド名（'is_read' | 'is_viewed' | 'is_message_viewed'）
         * @returns {boolean} 新着アイテムが存在する場合true
         */
        hasNewUnreadItemsSince(items, lastViewedAt, dateField, unreadField) {
            if (!items || items.length === 0) {
                return false
            }

            try {
                // lastViewedAtがnullの場合は1970-01-01T00:00:00Z（Unixエポック）を使用
                const lastViewedDate = new Date(lastViewedAt ?? '1970-01-01T00:00:00Z')

                // 無効な日付フォーマットの場合は新着なしとする
                if (isNaN(lastViewedDate.getTime())) {
                    return false
                }

                const unreadFields = Array.isArray(unreadField) ? unreadField : [unreadField]

                return items.some(item => {
                    const itemDateString = dateField === 'created_at'
                        ? item.created_at || item.createdAt
                        : item.sort_at || item.sortAt

                    if (!itemDateString) {
                        return false
                    }

                    try {
                        const itemDate = new Date(itemDateString)
                        const isAfterLastViewed = itemDate > lastViewedDate

                        // 最後に閲覧した時刻以降 かつ 未読フラグがfalseの場合のみtrue
                            if (isAfterLastViewed) {
                                // 未読フラグを複数優先順で確認
                                const unreadFlagValue = unreadFields
                                    .map(field => item[field])
                                    .find(value => value !== undefined && value !== null)
                                return unreadFlagValue === false
                            }

                        return false
                    } catch {
                        return false
                    }
                })
            } catch {
                return false
            }
        },
    },
}
</script>

<style scoped>
.global-navigation {
    box-sizing: border-box;
    background-color: #ffffff;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 0;
    margin: 0;
    max-width: 540px;
    left: 50%;
    transform: translateX(-50%);
}

.navigation-list {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0;
    padding-inline: 12px;
    width: 100%;
    height: 56px;
    list-style: none;
    box-sizing: border-box;
}

.navigation-item {
    flex: 1;
}

.navigation-link {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    border-radius: 12px;
    background-color: #ffffff;
    height: 50px;
    padding-block: 6px;
    text-decoration: none;
    color: #94939d; /* disabled色 */
    cursor: pointer;
}

.navigation-link.is-current {
    color: #27272A; /* default色 */
}

.navigation-label {
    font-family: "Noto Sans JP", sans-serif;
    font-size: 10px;
    font-weight: 400;
    line-height: 1.5;
}

.navigation-badge {
    position: absolute;
    top: 8px;
    left: calc(50% + 20px);
    transform: translateX(-100%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 8px;
    height: 8px;
    border-radius: 9999px;
    background-color: #D7001A;
}

.navigation-link svg {
    width: 25px;
    height: 25px;
    flex-shrink: 0;
}

.navigation-icon {
    height: 25px;
    width: 25px;
    flex-shrink: 0;
    fill: currentColor;
}
</style>
